var bestsellers = {
    init:function(){
        $(window).on("resize", function(){
            bestsellers.resize();
        })
        bestsellers.resize();
    },

    resize: function () {
        console.log("BEST SELLERS INIT");
        var _carousel = $(".akrolab-best-sellers .slider-products");

        if (_carousel.hasClass('slick-initialized')) {
            _carousel.slick('unslick');
        }

        var _slides_to_show = 1;
        var els = document.querySelectorAll(".slider-products-container");

        Array.prototype.forEach.call(els, function(el) {
            _slides_to_show = parseInt( window.getComputedStyle(el).getPropertyValue("--nbslide"));
        });
        var _centerMode = false;

        console.log("TEST WIDTH SLIDE : " + $(".akrolab-best-sellers .slide").css("width"));

        if(_slides_to_show == 1){
            _centerMode = true;
        }

        _carousel.slick({
            arrows:true,
            dots:false,
            infinite: false,
            variableWidth:true,
            slidesToShow: _slides_to_show,
            focusOnSelect: true,
            touchThreshold:500,
            centerMode:_centerMode,
            prevArrow: _carousel.parent().find(".arrow-container.left"),
            nextArrow: _carousel.parent().find(".arrow-container.right"),
        });
    }
}

$(window).on("load", function(){
    if($(".akrolab-best-sellers").length){
        bestsellers.init();
    }
})